import { z } from "zod";
import { CLIENTOPS_WEBSITE_DELIVERY_VERTICAL_ID } from "./entities.js";
export const WebsiteDeliveryLaunchChecklistItemV1Schema = z
    .object({
    itemId: z.string().min(1),
    label: z.string().min(1),
    category: z.enum(["DOMAIN_VALIDATION", "SECURITY_PRIVACY", "CALCULATION_TESTS", "LEGAL_REVIEW"]),
    required: z.boolean(),
    satisfied: z.boolean(),
    evidenceRef: z.string().min(1).optional(),
})
    .strict();
export const WebsiteDeliveryLaunchGateV1Schema = z
    .object({
    schemaVersion: z.literal("clientops.website-delivery-launch-gate.v1.0"),
    verticalId: z.literal(CLIENTOPS_WEBSITE_DELIVERY_VERTICAL_ID),
    checklistVersion: z.string().min(1),
    items: z.array(WebsiteDeliveryLaunchChecklistItemV1Schema).min(1),
    evaluatedAt: z.string().datetime(),
    readyToShip: z.boolean(),
    blockingReasons: z.array(z.string().min(1)),
})
    .strict();
const DEFAULT_CHECKLIST = [
    {
        itemId: "domain_validation",
        label: "Domain validation checklist complete",
        category: "DOMAIN_VALIDATION",
        required: true,
        satisfied: false,
    },
    {
        itemId: "security_privacy",
        label: "Security and privacy review complete",
        category: "SECURITY_PRIVACY",
        required: true,
        satisfied: false,
    },
    {
        itemId: "calc_tests",
        label: "Vertical calculation tests recorded",
        category: "CALCULATION_TESTS",
        required: true,
        satisfied: false,
    },
    {
        itemId: "legal_review",
        label: "Legal review boundaries satisfied",
        category: "LEGAL_REVIEW",
        required: true,
        satisfied: false,
    },
];
export function evaluateWebsiteDeliveryLaunchGate(input) {
    const evidence = input.evidenceByItemId ?? {};
    const satisfied = new Set(input.satisfiedItemIds);
    const items = DEFAULT_CHECKLIST.map((item) => {
        const ok = satisfied.has(item.itemId);
        return WebsiteDeliveryLaunchChecklistItemV1Schema.parse({
            ...item,
            satisfied: ok,
            evidenceRef: ok ? evidence[item.itemId] : undefined,
        });
    });
    const blockingReasons = items
        .filter((item) => item.required && !item.satisfied)
        .map((item) => `missing:${item.itemId}`);
    return WebsiteDeliveryLaunchGateV1Schema.parse({
        schemaVersion: "clientops.website-delivery-launch-gate.v1.0",
        verticalId: CLIENTOPS_WEBSITE_DELIVERY_VERTICAL_ID,
        checklistVersion: "v1.0",
        items,
        evaluatedAt: input.evaluatedAt ?? new Date().toISOString(),
        readyToShip: blockingReasons.length === 0,
        blockingReasons,
    });
}
//# sourceMappingURL=launch-checklist.js.map